import React from 'react';
import PropTypes from 'prop-types';
import UI from '../ui/ui';

class SearchResultsSidebar extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'SearchResultsSidebar';
        this.state = {
        	results : []
        }
        this.handleCancel = this.handleCancel.bind(this);
    }
    handleCancel(event) {
    	//Dispatch a clear event to the redux store
    	//TODO: Setup Cancel for map search.
    	this.setState({
    		results : []
    	});
    }
    render() {
    	if(this.state.results.length > 0) {
	        return (
	        	<UI.SidebarWidget title="Map Search Results" onCancel={this.handleCancel}>
	        		<ul>
	        			{this.state.results.map(function (result) {
	        				return <li>Item A</li>;
	        			})}
	        		</ul>
	        	</UI.SidebarWidget>
	        );
	    }
	    else {
	    	return <div></div>;
	    }
    }
}

export default SearchResultsSidebar;



// WEBPACK FOOTER //
// ./src/browser/components/maps/mapSearchResultsSidebar.js